// extracted by mini-css-extract-plugin
export default {"headshotsContainer":"headshots_headshotsContainer__LCH67","tableContainer":"headshots_tableContainer__YE1gi","selectedRow":"headshots_selectedRow__snkLN"};